<template>
<div>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<div class="content_card" v-if="!loading">

<div class="grid">
<div class="col-12">
<div class="content_card_content evaluation_wrap">

<div class="grid" v-if="data.flow">
<div class="col-12">
<div class="flex align-items-center justify-content-between" >
<div>

<p class="font-bold mt-0 ">{{suppliername}}</p>
<h2 class="text-primary mt-0">{{flowname}} <span class="text-purple-500" v-if="flowperiod"> - {{flowperiod}}</span></h2>
</div>

<Tag 
class="ml-2  mb-2 custom-chip" 
:value="flowtype" 
:style="'background-color:'+flowtypecolor"
/>
</div>
</div>
</div>

<template v-if="verification_data_missing">
  <div class="flex align-items-center justify-content-center pb-6 pt-2" v-if="$store.state.evaluation.evaluation">
  <h3 class="font-bold text-primary">Verification Data Missing</h3>

</div>
</template>


<template v-else>
  <template v-if="data.flow.type!=='education'">
  <QuizProgress v-if="$route.name!=='EvaluationInfo'"></QuizProgress>
  </template>
  <router-view v-slot="{ Component }" :key="$route.fullPath">
    <transition name="routeslide" mode="out-in">
      <component :is="Component" />
    </transition>
</router-view>
</template>





</div>


</div>
</div>
</div>

<template v-if="!loading">
<template v-if="data.flow.type!=='education'">
<QuizStatusChanger  v-if="$route.name!=='EvaluationInfo'" :verification_data_missing="verification_data_missing"></QuizStatusChanger>

<CorrectionRequestModal />

<NullReasonModal v-if="$route.name!=='EvaluationInfo'"></NullReasonModal>
<EvidenceModal v-if="$route.name!=='EvaluationInfo'"></EvidenceModal>
<QuizFinishModal></QuizFinishModal>
</template>
</template>


</div>
</template>

<script>
export default {

  name: 'Evaluation',

  data () {
    return {
    	data:null,
    	loading:true,
      verification_data_missing:false,
    }
  },
  sockets: {
    evaluation_check_socket_created(data) {
      //console.log("%c evaluation_check_socket_created ","color:white;background-color:#352f8d;font-weight:light;")
    },
    verification_check_socket_created(data) {
      //console.log("%c verification_check_socket_created ","color:white;background-color:#352f8d;font-weight:light;")
    },
    evaluation_supplier_data_updated(data) {
      console.log("%c evaluation_supplier_data_updated ","color:white;background-color:#352f8d;font-weight:light;")
      console.log(data.user_id)
      let user_id = this.$store.state.auth.user.id
      //console.log(user_id)
      if(user_id!==data.user_id)
      {
        console.log("check")
        let response_obj = {data:data}
        this.aftersubmitInputData(response_obj)
      }
      
    },
    evaluation_auditor_data_updated(data) {
      console.log("%c evaluation_auditor_data_updated ","color:white;background-color:#352f8d;font-weight:light;")
      console.log(data)
      let response_obj = {data:data}
      this.aftersubmitInputData(response_obj)
    },
    verification_session_ended(data) {
      //console.log("%c verification_session_ended ","color:white;background-color:#352f8d;font-weight:light;")
      this.$router.push({ name: 'SupplierBrand', params: { supplier_uuid:data } })
    },
    evidences_renewed(data) {
      console.log("%c evidences_renewed evidence","color:white;background-color:#352f8d;font-weight:light;")
      console.log(data)   
      this.getSingleInputfieldSubmissionData(data)  
      
    },
  },
   mounted()
  {
  	this.loading = true
  	this.getData()
  },
  computed:{
    flowtype()
    {
      if(this.data.flow.type=="self_evaluation")
      {
        return this.$store.state.languages.lang_phrases.self_evaluation
      }
      if(this.data.flow.type=="education")
      {
        return  this.$store.state.languages.lang_phrases.egitim
      }
      if(this.data.flow.type=="verification")
      {
        return  this.$store.state.languages.lang_phrases.verification
      }
      if(this.data.flow.type=="audit")
      {
        return  this.$store.state.languages.lang_phrases.audit
      }
    },
    flowtypecolor()
    {
      if(this.data.flow.type=="self_evaluation")
      {
        return "#ff6600"
      }
      if(this.data.flow.type=="education")
      {
        return "#3b82f6"
      }
      if(this.data.flow.type=="verification")
      {
        return "#7e2f8d"
      }
      if(this.data.flow.type=="audit")
      {
        return "#352f8d"
      }
    },
    flowname()
    {  
      return this.getTheTranslation(this.data.flow,"translation")
    },
    flowperiod()
    {
      if(this.data.projectperiod)
      {
        return this.data.projectperiod.name
      }
      return false
    },
    suppliername()
    {
      let name
      if(this.$store.state.evaluation.evaluation && this.$store.state.evaluation.evaluation.supplier)
      {
        name = this.$store.state.evaluation.evaluation.supplier.name
      }
      return name
    },
    show_evidence_modal()
    {
      return this.$store.state.evaluation.show_evidence_modal
    },
  	welcometext()
  	{
  		let preflang = this.$store.state.auth.user.preflang
  		if(this.data)
  		{
  			let text = this.data.flow.translations.find((item)=>{return item.language_id == preflang.id})
  			return text.description
  		}

  		return ""
  	}
  },
  watch:{
    show_evidence_modal(newval)
    {
      if(!newval)
      {
        this.$store.dispatch('evaluation/setSelectedInputfield',null)  
      }
    }
  },
  methods:{
  	async getData()
  	{
  		this.loading = await true
      let user = this.$store.state.auth.user
      let user_type
      this.$store.dispatch('evaluation/setCalculatedDataToSubmit',[]) 
      

      
  		this.data = await this.generalApiGet("audit/"+this.$route.params.id) 
      console.log("data")
      console.log(this.data)
      if(this.data.status=="deleted")
      {
        this.verification_data_missing = true
      }

      //set views by role
      if(user.userroles && user.userroles.length)
      {
        let userroles = user.userroles.map((element)=>{return element.name})

        if(userroles.includes("admin") || userroles.includes("auditor") || userroles.includes("planner")||userroles.includes("brand"))
        {
          this.$store.dispatch('evaluation/setMode',"admin_viewing") 
          this.$socket.emit('create_evaluation_check_socket', { flowsupplier_uuid: this.$route.params.id })
          user_type = await "admin"
        }
        if(userroles.includes("supplier") )
        {
          user_type = await "supplier"
          this.$socket.emit('create_verification_check_socket', { flowsupplier_uuid: this.$route.params.id })
          if(this.data.status=="finished" || this.data.status=="under_review" || this.data.status=="canceled" || this.data.status=="correction_requested")
          {
            await this.$store.dispatch('evaluation/setMode',"viewing") 
          }
          else
          {
            await this.$store.dispatch('evaluation/setMode',"submitting") 
          }
        }

      }
      //set views by role

      
      await this.$store.dispatch('evaluation/setEvaluation',this.data) 
      //get education data
      if(this.data.flow && this.data.flow.type=="education")
      {
        let audit_education_data = await this.generalApiGet("audit/get_audit_education_data/"+this.$route.params.id)
        
        await this.$store.dispatch('evaluation/setFlowVideos',audit_education_data) 
        //console.log("audit_education_data")
        console.log(audit_education_data)
        await this.gotoPage("EvaluationEducation")
      }
      //get education data

      //get self_evaluation data
      if(this.data.flow && this.data.flow.type=="self_evaluation")
      {
        let audit_inputfields_data = await this.generalApiGet("audit/get_audit_inputfields_data/"+this.$route.params.id)
        console.log(audit_inputfields_data)
        
        await this.$store.dispatch('evaluation/setNullreasons',audit_inputfields_data.nullreasons) 
        await this.$store.dispatch('evaluation/setCustomattributes',audit_inputfields_data.customattributes) 
        for(let condition of audit_inputfields_data.questionlist_conditions)
        {
          condition.conditions = await JSON.parse(condition.conditions)
          condition.outcome = await JSON.parse(condition.outcome)
        }
        await this.$store.dispatch('evaluation/setQuestionlistConditions',audit_inputfields_data.questionlist_conditions) 
        //await this.$store.dispatch('brands/setBrand',audit_inputfields_data.nullreasons) 
        await this.arrangeAuditInputfields(audit_inputfields_data)
        await this.calculateEvaluationProgress("first_init")
        await this.gotoPage("EvaluationProgress")
      }
      //get self_evaluation data


      //get verification data
      if(this.data.flow && this.data.flow.type=="verification")
      {
        let audit_inputfields_data = await this.generalApiGet("audit/get_audit_inputfields_data_for_verification/"+this.$route.params.id)
        console.log(audit_inputfields_data)
        //console.log("audit_inputfields_data")
        //console.log(audit_inputfields_data)
        if(audit_inputfields_data=="no_previous_data")
        {
          this.verification_data_missing = true
          this.loading = await false
          return false
        }
       
        await this.$store.dispatch('evaluation/setNullreasons',audit_inputfields_data.nullreasons) 
        await this.$store.dispatch('evaluation/setCustomattributes',audit_inputfields_data.customattributes) 
        await this.$store.dispatch('evaluation/setNonconformityTypes',audit_inputfields_data.nonconformity_types) 
        for(let condition of audit_inputfields_data.questionlist_conditions)
        {
          condition.conditions = await JSON.parse(condition.conditions)
          condition.outcome = await JSON.parse(condition.outcome)
        }
        await this.$store.dispatch('evaluation/setQuestionlistConditions',audit_inputfields_data.questionlist_conditions) 
        //await this.$store.dispatch('brands/setBrand',audit_inputfields_data.nullreasons) 
        
        await this.arrangeAuditInputfields(audit_inputfields_data)
        await this.calculateEvaluationProgress()
        if(user_type=="admin")
        {
          await this.$store.dispatch('evaluation/setMode',"admin_viewing") 

        }

        if(user_type=="supplier")
        {
          await this.$store.dispatch('evaluation/setMode',"supplier_viewing") 
        }
        await this.gotoPage("EvaluationProgress")
      }
      //get verification data


      
  		
      this.loading = await false
  	},
  	startFlow()
  	{
  		let flow = this.data.flow

  		if(flow.type=="education")
  		{
  			this.gotoPage("EvaluationEducation")
  		}
  		if(flow.type=="self_evaluation")
  		{
  			this.gotoPage("EvaluationProgress")
  		}
  		if(flow.type=="verification")
  		{
  			this.gotoPage("EvaluationProgress")
  		}
  	}
  	
  }
};
</script>

<style lang="css" scoped>
</style>